<template>
  <div class="cui-applications">
    <div class="cui-loading__container" v-if="spinner">
      <div class="cui-loading--center">
        <div class="cui-loading"></div>
      </div>
    </div>
    <div class="cui-action">
      <nav class="cui-breadcrumb">
        <ul class="cui-breadcrumb__links">
          <li class="cui-breadcrumb__link">
            <a @click="$router.push('/applications')">My Applications</a>
          </li>
          <li class="cui-breadcrumb__link cui-breadcrumb__link--current">
            <a @click="$router.push('/applications/manage')">Manage Applications</a>
          </li>
        </ul>
      </nav>
      <div class="cui-action__actions">
        <div class="cui-action__action-container" id="sort-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
            class="cui-action__icon cui-action__icons__space"
            viewBox="0 0 216 146"
          >
            <use
              xlink:href="node_modules/@covisint/cui-icons/dist/font-awesome/font-awesome-out.svg#sort14"
              class="cui-icon__ref"
            />
          </svg>
          <span class="cui-action__action-label">Sort</span>
        </div>

        <div
          class="cui-action__action-container"
          id="refine-button"
          off-click="this.refineClicked=false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
            class="cui-action__icon cui-action__icons__space"
            viewBox="0 0 216 146"
          >
            <use
              xlink:href="node_modules/@covisint/cui-icons/dist/font-awesome/font-awesome-out.svg#filter10"
              class="cui-icon__ref"
            />
          </svg>
          <span class="cui-action__action-label">Refine</span>
        </div>

        <div
          class="cui-action__action-container"
          id="popover-1-bottom"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid meet"
            class="cui-action__icon cui-action__icons__space"
            viewBox="0 0 48 48"
          >
            <use
              xlink:href="node_modules/@covisint/cui-icons/dist/icons/icons-out.svg#categories"
              class="cui-icon__ref"
            />
          </svg>
          <span class="cui-action__action-label">Categories</span>
          <b-popover target="popover-1-bottom" triggers="hover focus">
          <template v-slot:title>All ({{popupCount}})</template>
         <div class="cui-popover__row cui-popover--row__flex" v-for="category in categories" :key="category.name">
          <span @click="updateSearch('category', category.name)">{{category.name[0].text}}</span>
          <span>({{category.count}})</span>
        </div>
        </b-popover>

          <!---->
        </div>

        <svg
          @click="$router.push('/applications/request')"
          xmlns="http://www.w3.org/2000/svg"
          class="cui-action__icon cui-action__icon--new"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 48 48"
        >
          <defs>
            <ellipse id="path-1" cx="20" cy="19.672" rx="20" ry="19.672" />
            <filter
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
              filterUnits="objectBoundingBox"
              id="filter-2"
            >
              <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
                in="shadowBlurOuter1"
              />
            </filter>
          </defs>
          <g id="new-with-shadow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="New-2" transform="translate(3.000000, 1.000000)">
              <g id="Oval-73">
                <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1" />
                <use fill="currentColor" fill-rule="evenodd" xlink:href="#path-1" />
              </g>
              <path
                d="M22.1371429,17.5349883 L22.1371429,11.8697421 C22.1371429,10.7562937 21.2419442,9.86229506 20.1376608,9.86229506 L19.8623392,9.86229506 C18.7484919,9.86229506 17.8628571,10.7610597 17.8628571,11.8697421 L17.8628571,17.5349883 L12.197611,17.5349883 C11.0841625,17.5349883 10.1901639,18.4301869 10.1901639,19.5344704 L10.1901639,19.8097919 C10.1901639,20.9236392 11.0889286,21.809274 12.197611,21.809274 L17.8628571,21.809274 L17.8628571,27.4745202 C17.8628571,28.5879686 18.7580558,29.4819672 19.8623392,29.4819672 L20.1376608,29.4819672 C21.2515081,29.4819672 22.1371429,28.5832026 22.1371429,27.4745202 L22.1371429,21.809274 L27.802389,21.809274 C28.9158375,21.809274 29.8098361,20.9140754 29.8098361,19.8097919 L29.8098361,19.5344704 C29.8098361,18.4206231 28.9110714,17.5349883 27.802389,17.5349883 L22.1371429,17.5349883 Z"
                id="Rectangle-352"
                fill="#FFFFFF"
                fill-rule="evenodd"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="cui-action cui-action--alt">
      <div class="cui-input-button cui-input-button--alt-bg">
        <input
          class="cui-input-button__input ng-pristine ng-valid ng-empty ng-touched"
          ng-model="this.search['service.name']"
          focus-if
          placeholder="Search by application name"
          on-enter="this.updateSearchByName"
          style
        />
        <button class="cui-input-button__button" @click="updateSearchByName()">Search</button>
      </div>
    </div>
    <div class="cui-applications__main-container custom_padding">
      <!-- No applications message -->
      <p v-if="list.length===0">{{'cui-no-applications' | translate}}</p>
      <div>
        <b-table striped hover :items="list" :fields="fields"></b-table>
      </div>
       <div class="cui-paginate__container">
      <span class="cui-paginate__results-label">Results per page</span>
        <select  class="cui-paginate__select custom_paginate"
        v-model="pagination.perPage" @change="getPagination">
        <option
          v-for="entry in pagination.intervals"
          :key="entry"
          :value="entry"
        >{{ entry }}</option>
      </select>
  <div class="mt-3">
      <b-pagination v-model="pagination.currentPage" :per-page="pagination.perPage" :total-rows="pagination.rows" size="lg" @change="getPagination" align="left">
      </b-pagination>
  </div>
</div>
    </div>
  </div>
</template>

<script>
import APIHelpers from '../../../plugins/factory/APIHelpers'
export default {
  data () {
    return {
      spinner: false,
      checkedLocalStorage: false,
      list: [],
      viewList: [],
      count: 0,
      categories: [],
      search: {},
      categoriesClicked: false,
      popupCount: 0,
      fields: [
        {
          key: 'name[0].text',
          label: 'Application Name',
          sortable: false
        },
        {
          key: 'category[0].text',
          label: 'Category',
          sortable: false
        },
        {
          key: 'grant.status',
          label: 'Status',
          sortable: false
        }
      ],
      pagination: {
        rows: null,
        perPage: 50,
        currentPage: 1,
        intervals: [10, 25, 50, 100, 200]
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters.getUserInfo
    },
    hamburgerMenuOpenState () {
      return this.$store.getters.getHamburgerMenuOpenState
    }
  },
  created () {
    // ON LOAD START ------------------------------------------------------------------------------------------
    const loadStoredData = () => {
      const storedData = JSON.parse(localStorage.getItem('manageApplicationsList'))
      if (storedData) {
        this.spinner = true
        this.list = storedData.appList
        this.count = storedData.appCount
        this.categories = storedData.categories
        this.spinner = false
      }
      this.checkedLocalStorage = true
      this.onLoad(false)
    }
    loadStoredData()
    this.onLoad(true)
  },
  methods: {
    onLoad (previouslyLoaded) {
      if (this.userData) {
        if (previouslyLoaded) {
          this.spinner = true
        } else {
          this.spinner = true
          this.$API.getPersonAppCategories({personId: this.userData.user.id})
            .then(res => {
              this.categories = res
              this.getCountsOfcategories()
            })
            .fail(err => {
              this.spinner = false
              console.log('err', err)
            })
            .done(() => {
              this.spinner = false
              console.log('done')
            })
        }
        this.search.pageSize = this.search.pageSize
        const opts = {
          personId: this.userData.user.id,
          useCuid: true,
          qs: APIHelpers.apiHelpers.getQs(this.search)
        }

        const promises = [
          this.$API.getPersonGrantedApps(opts),
          this.$API.getPersonGrantedAppCount(opts)
        ]

        Promise.all(promises)
          .then(res => {
            this.count = res[1]
            this.list = res[0]
            const storageData = {
              appList: this.list,
              appCount: this.count,
              categories: this.categories
            }
            localStorage.setItem('myApplicationsList', JSON.stringify(storageData))
          })
          .catch(err => {
            console.log('err', err)
          })
          .finally(() => {
            if (previouslyLoaded) {
              this.spinner = false
              console.log('err')
            } else {
            }
          })
        this.getCountsOfStatus('active')
        this.getCountsOfStatus('suspended')
        this.getCountsOfStatus(undefined)
      }
    },
    // HELPER FUNCTIONS START ---------------------------------------------------------------------------------
    switchBetween (property, firstValue, secondValue) {
      // helper function to switch a property between two values or set to undefined if values not passed
      if (!firstValue) {
        this.search[property] = undefined
        return
      }
      this.search[property] = this.search[property] === firstValue
        ? secondValue
        : firstValue
    },
    getCountsOfStatus (qsValue) {
      let opts = {
        personId: this.userData.user.id,
        useCuid: true
      }
      if (qsValue) {
        opts.qs = [['grant.status', qsValue]]
      }
      this.$API.getPersonGrantedAppCount(opts)
        .then(res => {
          if (!qsValue) {
            this.popupCount = res
          } else if (qsValue === 'active') {
            this.activeCount = res
          } else {
            this.suspendedCount = res
          }
        })
        .fail(err => {
          console.log('err', err)
        })
    },
    getCountsOfcategories () {
      this.categories.forEach((category, index) => {
        let opts = {
          personId: this.userData.user.id,
          useCuid: true
        }
        opts.qs = [['service.category', category.name[0].text]]
        this.$API.getPersonGrantedAppCount(opts)
          .then(res => {
            category.count = res
            if (index === this.categories.length - 1) {
              console.log(index)
            };
          })
          .fail(err => {
            console.log(err)
            if (index === this.categories.length - 1) {
              console.log(index)
            };
          })
      })
    },
    pageChange (newpage) {
      this.updateSearch('page', newpage)
    },
    updateSearchByName () {
      this.updateSearch('name', this.search['service.name'])
    },
    updateSearch (updateType, updateValue) {
      switch (updateType) {
        case 'alphabetic':
          this.switchBetween('sortBy', '+service.name', '-service.name')
          break
        case 'date':
          this.switchBetween('sortBy', '+grant.instant', '-grant.instant')
          break
        case 'status':
          this.search.page = 1
          this.search['grant.status'] = updateValue
          break
        case 'category':
          this.search.page = 1
          this.search['service.category'] = updateValue
          break
        case 'name':
          this.search.page = 1
          break
      }
    },
    goToDetails (application) {
      localStorage.setItem('myAppDetail', JSON.stringify(application))
      // $state.go('applications.myApplicationDetails', opts)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/applications/ManageApplication.vue